import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { CAMPAIGN_STATUS } from '@app/constant/CampaignConstant'
import { InertiaLink } from '@inertiajs/inertia-react'
import PageviewIcon from '@mui/icons-material/Pageview'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { useTranslation } from 'react-i18next'

export default function CampaignIndex({ campaignRequests }) {
  const { t } = useTranslation()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataGrid
          enableIndexColumn
          columns={[
            {
              id: 'name',
              Header: t('CAMPAIGNS.NAME'),
              accessor: 'name',
              type: 'string',
            },
            {
              id: 'prepaid_vouchers_count',
              Header: t('CAMPAIGNS.TOTAL_PREPAID_VOUCHERS'),
              accessor: 'prepaid_vouchers_count',
              type: 'number',
            },
            {
              id: 'postpaid_vouchers_count',
              Header: t('CAMPAIGNS.TOTAL_POSTPAID_VOUCHERS'),
              accessor: 'postpaid_vouchers_count',
              type: 'number',
            },
            {
              id: 'vouchers_count',
              Header: t('CAMPAIGNS.TOTAL_VOUCHERS'),
              accessor: 'vouchers_count',
              type: 'number',
              autoHide: true,
            },
            {
              id: 'total_estimate_cost',
              Header: t('CAMPAIGNS.TOTAL_ESTIMATE_PRICES'),
              accessor: 'total_estimate_cost',
              type: 'number',
              disableFilters: true,
            },
            {
              id: 'total_get_codes',
              Header: t('CAMPAIGNS.TOTAL_GET_CODES'),
              accessor: 'total_get_codes',
              type: 'number',
              autoHide: true,
            },
            {
              id: 'updated_at',
              Header: t('CAMPAIGNS.REQUESTED_TIME'),
              accessor: 'updated_at',
              type: 'dateTime',
              disableFilters: true,
              disableSortBy: true,
            },
            {
              id: 'status',
              Header: t('CAMPAIGNS.STATUS'),
              accessor: ({ status }) => t(`CAMPAIGNS.${status.toUpperCase()}`),
              type: 'singleSelect',
              options: [
                { value: CAMPAIGN_STATUS.REJECTED, name: t('CAMPAIGNS.REJECTED') },
                { value: CAMPAIGN_STATUS.REQUESTED, name: t('CAMPAIGNS.REQUESTED') },
              ],
              autoHide: true,
            },
            {
              id: 'action',
              Header: t('CAMPAIGNS.ACTIONS'),
              disableFilters: true,
              Cell: ({ row }) => (
                <IconButton component={InertiaLink} href={route('partner.campaigns.requested.show', row.original.id)}>
                  <PageviewIcon />
                </IconButton>
              ),
            },
          ]}
          data={campaignRequests}
          routeName="partner.campaigns.request"
        />
      </Grid>
    </Grid>
  )
}
